
         <div *ngIf="templateType=='Email'" class="popup-content-outer view-email">
          <div class="view-email__header">
            <!-- <img  alt="{{imagealt}}" height="65" title="{{imageTitle}}"> -->
          </div>
          <div class="view-email__content">
            <h1>{{emailTitle}}</h1>
            <h3>{{subject}}</h3>
            <div [innerHtml]="emailTextArea"></div>
          </div>
        </div> 

        <div *ngIf="templateType=='SMS'" class="popup-content-outer view-email">
          <div class="view-email__header">
            <!-- <img *ngIf="imageUrl" [src]="imageUrl" alt="{{imagealt}}" height="65" title="{{imageTitle}}"> -->
          </div>
          <div class="view-email__content">
            <h1>{{smsTitle}}</h1>
            <div [innerHtml]="smsTextArea"></div>
          </div>
        </div>